import { useMutation, useQueryClient } from '@tanstack/react-query';
import { setDefaultBillingAddress } from '../../api/apiStorefront';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const useSetDefaultBillingAddress = () => {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation({
        mutationFn: async (addressId) => {
            if (!addressId) {
                throw new Error('Address ID is required');
            }
            const response = await setDefaultBillingAddress(addressId);
            return response.data;
        },
        onSuccess: (data) => {
            toast.success(t('address.defaultBillingSet', 'Default billing address set successfully!'));
            // Invalidate multiple queries to ensure fresh data
            queryClient.invalidateQueries({ queryKey: ['customer-addresses'] });
            queryClient.invalidateQueries({ queryKey: ['customer'] });
        },
        onError: (error) => {
            console.error('Error setting default billing address:', error);
            const message = error.response?.data?.message || error.message || t('address.defaultBillingError', 'Failed to set default billing address');
            toast.error(message);
        },
    });
};
